
import { defineComponent, PropType } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        TheButton
    },
    props: {
        value: {
            type: String as PropType<'ftl' | 'ltl'>,
            default: 'ftl'
        },
    },
    emits: ['export-data', 'export-ltl-data'],
    setup(props, { emit }) {
        const onExportData = () => {
            emit('export-data')
        }

        const onExportLtlData = () => {
            emit('export-ltl-data')
        }

        return {
            onExportData,
            onExportLtlData
        }
    }
})
